import './retentionGroupsWidget.scss'
import { Suspense } from 'react'
import { Link } from 'react-router'

import { Title } from '@/shared/ui'
import { RetentionGroupsChart } from './RetentionGroupsChart'
import { AnalyticsSelectors } from '@/features/analytics'
import { useInviteLinksStore } from '@/features/analytics/model'

import { GroupsChannelFormattedRowType } from '../../invite-links/hooks/useGroupsChannelsFormattedRows'
import { RetentionGroupsTable } from './RetentionGroupsTable'
import {
    useActiveWorkspace,
    workspacePath,
} from '@/true-fsd/data/advertiser-account'

export type RetentionGroupsWidgetProps = {
    channelId: number
}
export const RetentionGroupsWidget = ({
    channelId,
}: RetentionGroupsWidgetProps) => {
    const {
        startDateRetentionGroup,
        endDateRetentionGroup,
        usersSortRetention,
        subscriberStatusSortRetentionGroup,
        trafficSourceSortRetentionGroup,
        detalizationSortRetentionGroup,
        selectedRetentionGroups,
        toggleSelectedRetentionGroup,
        setStartDateRetentionGroup,
        setEndDateRetentionGroup,
        setTrafficSourceSortRetentionGroup,
        setDetalizationSortRetentionGroup,
        setUsersSortRetentionGroup,
        setSubscriberStatusSortRetentionGroup,
    } = useInviteLinksStore()

    const handleRowSelect = (row: GroupsChannelFormattedRowType) => {
        if (channelId) {
            toggleSelectedRetentionGroup(channelId, row.id)
        }
    }

    const isRowSelected = (row: GroupsChannelFormattedRowType) => {
        return (selectedRetentionGroups[channelId] || []).includes(row.id)
    }

    const { activeWorkspace } = useActiveWorkspace()

    return (
        <div className="retention-groups-widget">
            <div>
                <Title className="title">Удержание подписчиков</Title>
                <div className="retention-groups-widget__link">
                    <div className="link">
                        <Link
                            to={workspacePath(
                                activeWorkspace,
                                `analytics/retention`
                            )}
                            className="campaigns-link"
                        >
                            Группы
                        </Link>
                    </div>{' '}
                    / Все
                </div>
            </div>
            <Suspense fallback={<div>Loading...</div>}>
                <AnalyticsSelectors
                    trafficSource={trafficSourceSortRetentionGroup}
                    detalization={detalizationSortRetentionGroup}
                    users={usersSortRetention}
                    subscribers={subscriberStatusSortRetentionGroup}
                    datePicker={{
                        startDate: startDateRetentionGroup,
                        endDate: endDateRetentionGroup,
                    }}
                    onTrafficSourceSelect={setTrafficSourceSortRetentionGroup}
                    onDetalizationSelect={setDetalizationSortRetentionGroup}
                    onUsersSelect={setUsersSortRetentionGroup}
                    onSubscribersSelect={setSubscriberStatusSortRetentionGroup}
                    onDateChange={{
                        onFromDateChange: setStartDateRetentionGroup,
                        onToDateChange: setEndDateRetentionGroup,
                    }}
                    mode="Retention"
                />
                <RetentionGroupsChart channelId={channelId} />
                <RetentionGroupsTable
                    channelId={channelId}
                    handleCheckboxChange={handleRowSelect}
                    isRowSelected={isRowSelected}
                />
            </Suspense>
        </div>
    )
}
